import PropTypes from 'prop-types'
import React from 'react'
import Link from 'next/link'
import { getProfileAdsQuery } from 'SRC/modules/users/Profile/selectors'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import withTranslation from 'next-translate/withTranslation'
import { setProfileLoading, setNotifications } from 'SRC/modules/users/Profile/actions'
import { SearchInput } from 'SRC/modules/ads/filter/components'

class Menu extends React.PureComponent {
  constructor (props) {
    super(props)
    this.formRef = React.createRef()

    const { i18n: { t } } = props

    this.baseAs = '/profil/oglasi'
    this.baseHref = '/profile'
    this.baseHrefQuery = {page: 'oglasi'}

    this.adStatuses = {
      ACTIVE: {
        title: t('common:adsPublishedText').toUpperCase(),
        code: 'Published'
      },
      UNPUBLISHED: {
        title: t('common:adsUnpublishedText').toUpperCase(),
        code: 'Unpublished'
      },
      REJECTED: {
        title: t('common:Odbijeni').toUpperCase(),
        code: 'Rejected'
      },
      INACTIVE: {
        title: t('common:Neaktivni').toUpperCase(),
        code: 'Inactive'
      },
      SOLD: {
        title: t('common:Prodati').toUpperCase(),
        code: 'Sold'
      }
    }
  }

  renderItems = currentStatus => {
    return Object.keys(this.adStatuses).map(status => {
      let hrefUrl = { pathname: this.baseHref, query: this.baseHrefQuery }
      let asUrl = { pathname: this.baseAs }

      hrefUrl.query = { ...this.baseHrefQuery, status: this.adStatuses[status].code }
      asUrl.query = { status: this.adStatuses[status].code }

      return <div className={`profile-ads-menu-item ${currentStatus === this.adStatuses[status].code ? 'active' : ''}`}
        key={`${status}-ads`}>
        <Link href={hrefUrl} as={asUrl}>
          <a>
            {this.adStatuses[status].title}
          </a>
        </Link>
      </div>
    })
  }

  render () {
    const { profileAdsQuery } = this.props

    const currentStatus = profileAdsQuery ? profileAdsQuery.status : 'Published'

    return <section className='profile-ads-menu poruke-pretraga'>
      {this.renderItems(currentStatus)}
      <div className='input-pretraga'>
        <SearchInput baseAs={this.baseAs} baseHref={this.baseHref} baseHrefQuery={this.baseHrefQuery} dropdownStyle='profile'
          profileAdStatus={currentStatus} />
      </div>
    </section>
  }
}

const mapStateToProps = state => ({
  profileAdsQuery: getProfileAdsQuery(state)
})

Menu.propTypes = {
  profileAdsQuery: PropTypes.shape({
    status: PropTypes.string
  })
}

const enhance = compose(
  connect(mapStateToProps, {setProfileLoading, setNotifications}),
  withTranslation
)

export default enhance(Menu)
